import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { combineLatest, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { AudioVideoConnectionMonitorSelectors } from 'src/app/features/audio-video-connection-monitor/store';
import { ClientSelectors } from 'src/app/features/client';
import { ClientTheme } from 'src/app/features/client/models';
import { ModalsActions, ModalSize } from 'src/app/features/modals';
import { MsalAuthSelectors } from 'src/app/features/msal-auth';
import { PackageUsersSelectors } from 'src/app/features/package-users';
import { DEFAULT_APPLICATION_PHONE_NUMBER } from 'src/app/features/shared/constants';
import { RootStoreState } from 'src/app/store';

import { AudioVideoModalContainerComponent } from 'src/app/features/layout/components/audio-video-modal/audio-video-modal-container.component';
import { SigningDetailsComponent } from '../components';

@Component({
    selector: 'app-nav-bar-pre-session',
    templateUrl: './nav-bar-pre-session.component.html',
    styleUrls: ['../nav-bar/nav-bar.component.scss'],
    standalone: false
})
export class NavBarPreSessionComponent implements OnDestroy, OnInit {

  canViewOrderDetailsButton$: Observable<boolean>;
  canViewDeviceSettingsButton$: Observable<boolean>;
  clientTheme$: Observable<ClientTheme>;
  onDestroyNotifier = new Subject();

  nexsysSupportNumber = DEFAULT_APPLICATION_PHONE_NUMBER;

  constructor(private readonly store: Store<RootStoreState.State>) {}

  ngOnInit(): void {
    this.canViewOrderDetailsButton$ = combineLatest([
      this.store.pipe(select(PackageUsersSelectors.getIsActivePackageUserSigningAgent)),
      this.store.pipe(select(MsalAuthSelectors.getIsUserVerified)),
    ]).pipe(map(([isSigningAgent, msalIsVerified]) => isSigningAgent || msalIsVerified));

    this.canViewDeviceSettingsButton$ = this.store.pipe(
      select(AudioVideoConnectionMonitorSelectors.getCanDeviceSettingsModalBeDisplayed)
    );

    this.clientTheme$ = this.store.pipe(select(ClientSelectors.getClientTheme));
  }

  ngOnDestroy(): void {
    this.onDestroyNotifier.next(undefined);
    this.onDestroyNotifier.complete();
  }

  openDetailsModal() {
    this.store.dispatch(
      ModalsActions.SetStandaloneModalComponent({
        payload: {
          component: SigningDetailsComponent,
        },
      })
    );
  }

  openChangeAudioVideoModal() {
    this.store.dispatch(
      ModalsActions.SetStandaloneModalComponent({
        payload: {
          component: AudioVideoModalContainerComponent,
          modalSize: ModalSize.large,
        },
      })
    );
  }

  openCancelSigningModal() {
    this.store.dispatch(ModalsActions.OpenCancelSigningModal());
  }
}
